import React, { useState, useEffect } from 'react';
import { useNavigate, Link, useSearchParams } from 'react-router-dom';
import api from '../api';

const FARBEN = ['#6366f1','#f59e0b','#10b981','#ef4444','#3b82f6','#8b5cf6','#ec4899','#64748b'];

export default function BehaelterPage() {
  const [searchParams] = useSearchParams();
  const [behaelter, setBehaelter] = useState([]);
  const [standorte, setStandorte] = useState([]);
  const [filter, setFilter] = useState(searchParams.get('standort') || '');
  const [zeigForm, setZeigForm] = useState(false);
  const [hinweis, setHinweis] = useState('');
  const [form, setForm] = useState({ name: '', beschreibung: '', standort_id: '', farbe: '#f59e0b' });
  const [speichert, setSpeichert] = useState(false);
  const [fehler, setFehler] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    laden();
    if (sessionStorage.getItem('pendingQrCode')) {
      setZeigForm(true);
      setHinweis('Der gescannte QR-Code wird der neuen Kiste nach dem Erstellen zugeordnet.');
    }
  }, []);

  async function laden() {
    const [b, s] = await Promise.all([api.get('/behaelter'), api.get('/standorte')]);
    setBehaelter(b.data);
    setStandorte(s.data);
  }

  async function erstellen(e) {
    e.preventDefault();
    if (!form.name.trim()) { setFehler('Bitte gib einen Namen für die Kiste ein.'); return; }
    setSpeichert(true);
    setFehler('');
    try {
      const r = await api.post('/behaelter', form);
      const pendingQrCode = sessionStorage.getItem('pendingQrCode');
      if (pendingQrCode) {
        await api.post(`/behaelter/${r.data.id}/qr/assign`, { code: pendingQrCode });
        sessionStorage.removeItem('pendingQrCode');
      }
      setZeigForm(false);
      setHinweis('');
      setForm({ name: '', beschreibung: '', standort_id: '', farbe: '#f59e0b' });
      laden();
      navigate(`/behaelter/${r.data.id}`);
    } catch {
      setFehler('Die Kiste konnte nicht erstellt werden. Bitte versuche es erneut.');
    } finally {
      setSpeichert(false);
    }
  }

  async function loeschen(id, name, e) {
    e.stopPropagation();
    if (!window.confirm(`Kiste „${name}" wirklich löschen?\n\nAlle darin enthaltenen Artikel werden ebenfalls gelöscht. Diese Aktion kann nicht rückgängig gemacht werden.`)) return;
    try {
      await api.delete(`/behaelter/${id}`);
      laden();
    } catch {
      alert('Die Kiste konnte nicht gelöscht werden. Bitte versuche es erneut.');
    }
  }

  function formSchliessen() {
    sessionStorage.removeItem('pendingQrCode');
    setZeigForm(false);
    setHinweis('');
    setFehler('');
  }

  const gefilter = filter ? behaelter.filter(b => b.standort_id == filter) : behaelter;
  const inp = { width: '100%', padding: '10px 14px', borderRadius: '10px', border: '1px solid #e2e8f0', fontSize: '14px', boxSizing: 'border-box', marginBottom: '10px' };

  const gruppen = {};
  gefilter.forEach(b => {
    const key = b.standort_name || 'Kein Standort';
    if (!gruppen[key]) gruppen[key] = { icon: b.standort_icon || '📦', items: [] };
    gruppen[key].items.push(b);
  });

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '4px' }}>
        <h1 style={{ margin: 0, fontSize: '22px', fontWeight: '700' }}>📦 Kisten</h1>
        <button onClick={() => setZeigForm(true)}
          style={{ padding: '10px 16px', background: '#f59e0b', color: 'white', border: 'none', borderRadius: '10px', cursor: 'pointer', fontWeight: '600' }}>
          + Neue Kiste
        </button>
      </div>
      <p style={{ color: '#64748b', fontSize: '13px', marginTop: '4px', marginBottom: '12px' }}>Kisten öffnen, durchsuchen oder neue anlegen.</p>

      {standorte.length > 0 && (
        <select value={filter} onChange={e => setFilter(e.target.value)}
          aria-label="Nach Standort filtern"
          style={{ ...inp, marginBottom: '16px' }}>
          <option value="">Alle Standorte</option>
          {standorte.map(s => <option key={s.id} value={s.id}>{s.icon} {s.name}</option>)}
        </select>
      )}

      {Object.entries(gruppen).map(([standort, g]) => (
        <div key={standort} style={{ marginBottom: '20px' }}>
          <div style={{ fontWeight: '700', fontSize: '13px', color: '#64748b', marginBottom: '8px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>{g.icon} {standort}</div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
            {g.items.map(b => (
              <div key={b.id} onClick={() => navigate(`/behaelter/${b.id}`)}
                style={{ background: 'white', borderRadius: '12px', padding: '14px 16px', boxShadow: '0 1px 4px rgba(0,0,0,0.06)', borderLeft: `4px solid ${b.farbe}`, cursor: 'pointer', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <div>
                  <div style={{ fontWeight: '700', fontSize: '15px' }}>{b.name}</div>
                  {b.beschreibung && <div style={{ color: '#64748b', fontSize: '12px', marginTop: '2px' }}>{b.beschreibung}</div>}
                  <div style={{ color: '#94a3b8', fontSize: '11px', marginTop: '4px' }}>📋 {b.artikel_anzahl || 0} Artikel</div>
                </div>
                <div style={{ display: 'flex', gap: '6px', alignItems: 'center' }}>
                  {b.qr_code && (
                    <button
                      onClick={e => { e.stopPropagation(); window.open(`/behaelter/${b.id}/etikett`, '_blank'); }}
                      aria-label={`Etikett für ${b.name} drucken`} title="Etikett drucken"
                      style={{ background: '#fef3c7', border: 'none', borderRadius: '8px', padding: '8px 10px', cursor: 'pointer', color: '#d97706', lineHeight: 1, fontSize: '14px' }}>🏷️</button>
                  )}
                  <span style={{ fontSize: '20px', color: '#94a3b8' }}>›</span>
                  <button onClick={e => loeschen(b.id, b.name, e)}
                    aria-label={`Kiste ${b.name} löschen`} title="Kiste löschen"
                    style={{ background: '#fee2e2', border: 'none', borderRadius: '8px', padding: '8px 10px', cursor: 'pointer', color: '#ef4444', lineHeight: 1 }}>🗑️</button>
                </div>
              </div>
            ))}
          </div>
        </div>
      ))}

      {gefilter.length === 0 && behaelter.length === 0 && (
        <div style={{ textAlign: 'center', padding: '60px 20px', color: '#94a3b8' }}>
          <div style={{ fontSize: '48px' }}>📦</div>
          <div style={{ marginTop: '12px', fontWeight: '600', fontSize: '16px', color: '#64748b' }}>Noch keine Kisten vorhanden</div>
          <div style={{ fontSize: '13px', marginTop: '6px', marginBottom: '20px' }}>Lege die erste Kiste an, um dein Lager aufzubauen.</div>
          <button onClick={() => setZeigForm(true)}
            style={{ padding: '12px 24px', background: '#f59e0b', color: 'white', border: 'none', borderRadius: '10px', fontWeight: '700', cursor: 'pointer', fontSize: '15px' }}>
            + Erste Kiste anlegen
          </button>
        </div>
      )}

      {gefilter.length === 0 && behaelter.length > 0 && (
        <div style={{ textAlign: 'center', padding: '40px 20px', color: '#94a3b8' }}>
          <div style={{ fontSize: '40px' }}>🔍</div>
          <div style={{ marginTop: '8px', fontWeight: '600', color: '#64748b' }}>Keine Kisten an diesem Standort</div>
          <button onClick={() => { setForm(f => ({...f, standort_id: filter})); setZeigForm(true); }}
            style={{ marginTop: '12px', padding: '10px 20px', background: '#f59e0b', color: 'white', border: 'none', borderRadius: '10px', cursor: 'pointer', fontWeight: '700' }}>
            + Kiste hier anlegen
          </button>
        </div>
      )}

      {zeigForm && (
        <div role="dialog" aria-label="Neue Kiste anlegen" style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'flex-end', zIndex: 100 }}>
          <div style={{ background: 'white', borderRadius: '20px 20px 0 0', padding: '24px', width: '100%', maxWidth: '600px', margin: '0 auto', maxHeight: '90vh', overflowY: 'auto' }}>
            <h2 style={{ margin: '0 0 16px' }}>📦 Neue Kiste anlegen</h2>
            {hinweis && <div style={{ background: '#eef2ff', color: '#4338ca', padding: '10px', borderRadius: '10px', marginBottom: '12px', fontSize: '13px' }}>{hinweis}</div>}
            {fehler && <div role="alert" style={{ background: '#fee2e2', color: '#b91c1c', padding: '10px', borderRadius: '10px', marginBottom: '12px', fontSize: '13px' }}>{fehler}</div>}
            <form onSubmit={erstellen}>
              <label style={{ display: 'block', fontSize: '13px', fontWeight: '600', marginBottom: '4px' }}>
                Name der Kiste <span style={{ color: '#ef4444' }}>*</span>
              </label>
              <input style={inp} placeholder="z.B. Wohnzimmer-Box, Werkzeugkiste" value={form.name} onChange={e => setForm({...form, name: e.target.value})} required autoFocus />

              <label style={{ display: 'block', fontSize: '13px', fontWeight: '600', marginBottom: '4px' }}>
                Beschreibung <span style={{ color: '#94a3b8', fontWeight: '400' }}>(optional)</span>
              </label>
              <input style={inp} placeholder="Wofür wird diese Kiste verwendet?" value={form.beschreibung} onChange={e => setForm({...form, beschreibung: e.target.value})} />

              {standorte.length > 0 && (
                <>
                  <label style={{ display: 'block', fontSize: '13px', fontWeight: '600', marginBottom: '4px' }}>Standort</label>
                  <select style={inp} value={form.standort_id} onChange={e => setForm({...form, standort_id: e.target.value})}>
                    <option value="">– Kein Standort –</option>
                    {standorte.map(s => <option key={s.id} value={s.id}>{s.icon} {s.name}</option>)}
                  </select>
                </>
              )}
              {standorte.length === 0 && (
                <div style={{ fontSize: '12px', color: '#94a3b8', marginBottom: '12px', padding: '8px 12px', background: '#f8fafc', borderRadius: '8px' }}>
                  💡 Tipp: Mit <Link to="/einstellungen" onClick={() => setZeigForm(false)} style={{ color: '#6366f1', fontWeight: '600' }}>Standorten</Link> kannst du Kisten nach Ort gruppieren – z.B. Keller, Dachboden, Garage.
                </div>
              )}

              <div style={{ marginBottom: '20px' }}>
                <label style={{ fontSize: '13px', fontWeight: '600', display: 'block', marginBottom: '8px' }}>Farbe</label>
                <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
                  {FARBEN.map(f => (
                    <button key={f} type="button" onClick={() => setForm({...form, farbe: f})}
                      aria-label={`Farbe auswählen`}
                      style={{ width: '32px', height: '32px', borderRadius: '50%', background: f, border: `3px solid ${form.farbe === f ? '#1e293b' : 'transparent'}`, cursor: 'pointer' }} />
                  ))}
                </div>
              </div>

              <div style={{ display: 'flex', gap: '10px' }}>
                <button type="button" onClick={formSchliessen}
                  style={{ flex: 1, padding: '12px', background: '#f1f5f9', border: 'none', borderRadius: '10px', cursor: 'pointer', fontWeight: '600' }}>
                  Abbrechen
                </button>
                <button type="submit" disabled={speichert}
                  style={{ flex: 2, padding: '12px', background: speichert ? '#d97706' : '#f59e0b', color: 'white', border: 'none', borderRadius: '10px', cursor: speichert ? 'wait' : 'pointer', fontWeight: '700', opacity: speichert ? 0.85 : 1 }}>
                  {speichert ? '⏳ Wird erstellt...' : '✅ Kiste erstellen'}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}
